module.exports = __webpack_public_path__ + "static/media/logo.f53697c8.png";